import { Divider } from '@/components/base/divider'
import { Outlet } from 'react-router'

export const Layout = () => {
  return (
    <>
      <div className="flex flex-col gap-4">
        <div className="flex flex-row gap-8 items-center">
          Maintenance
        </div>
        <Divider />
        <Outlet />
      </div>
    </>
  )
}
